export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly detail: Record<string, unknown> = {},
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function api<T>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const res = await fetch(path, {
    method: init.method ?? 'GET',
    headers: init.body !== undefined ? { 'content-type': 'application/json' } : undefined,
    body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    credentials: 'same-origin',
  });
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => ({}))) as { error?: string; message?: string; detail?: Record<string, unknown> };
  if (!res.ok) throw new ApiError(res.status, data.error ?? 'error', data.message ?? res.statusText, data.detail);
  return data as T;
}

export interface Passkey {
  id: string;
  name: string;
  createdAt: string;
  lastUsedAt: string | null;
  backedUp: boolean;
}

export interface Membership {
  tenantId: string;
  name: string;
  slug: string;
  role: 'owner' | 'admin' | 'member';
}

export interface Me {
  user: { id: string; email: string; displayName: string };
  mfaVerified: boolean;
  factors: { totp: boolean; passkeys: Passkey[] };
  memberships: Membership[];
  openMfaReset: boolean;
  /** Platform operator: the error log is theirs. Set in the database, not through the UI. */
  isOperator: boolean;
}

export const hasFactors = (me: Me) => me.factors.totp || me.factors.passkeys.length > 0;
